
import { makeApi } from "./callApi";

export class MerchantApi {
    static async getMerchantDisplayList() {
        const response = await makeApi("/merchant/display-merchants/get", "GET");
        return response.data;
    }

    static async getMerchantById(merchantId) {
        const response = await makeApi(`/merchant/${merchantId}`, "GET");
        return response.data;
    }
}